import React from 'react'
import PropTypes from 'prop-types'
import { Step, Typography, Stepper, StepLabel, Grid, Divider } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import SaveIcon from '@material-ui/icons/Save'

import { CustomButton, ModalConfirmacao } from 'components'
import { getLabelGrauRelacaoCadaver } from 'helpers/labels'
import { FormPessoaReconhecimento } from '../ReconhecimentoCadaver/FormPessoaReconhecimento'
import { FormConclusaoEntrega } from './FormConclusaoEntrega'
import { FormArquivos } from './FormArquivos'
import { useFormEntrega } from './hooks/useFormEntrega'
import useStyles from './Form.styles'

export const Form = (props) => {
  const { cadaver } = props
  const classes = useStyles()

  const {
    activeStep,
    steps,
    recebedorForm,
    conclusaoForm,
    processando,
    openEspelho,
    setOpenEspelho,
    dadosFormatados,
    formError,
    handleBack,
    handleNext,
    handleConfirmar,
    router,
  } = useFormEntrega({ cadaver })

  const getStepTitle = () => {
    switch (activeStep) {
      case 0:
        return 'DADOS DO RECEBEDOR'
      case 1:
        return 'CONCLUSÃO DA ENTREGA'
      case 2:
        return 'DOCUMENTOS RELACIONADOS'
      default:
        return ''
    }
  }

  const getFormContent = () => {
    switch (activeStep) {
      case 0:
        return <FormPessoaReconhecimento isReconhecedor={true} pessoaForm={recebedorForm} />
      case 1:
        return <FormConclusaoEntrega conclusaoForm={conclusaoForm} />
      case 2:
        return (
          <FormArquivos
            form={recebedorForm}
            processando={processando}
            idCadaver={cadaver.id}
            formConclusao={conclusaoForm}
          />
        )
      default:
        return null
    }
  }

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} alternativeLabel className={classes.stepper}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <Grid container justifyContent="space-between" spacing={3} className={classes.contentSplitter}>
        <Grid item md={12} sm={12} xs={12} className={classes.downContainer}>
          <Grid container spacing={2}>

            <Grid item md={12} sm={12} xs={12}>
              {getFormContent()}
            </Grid>

            <Grid item md={12} sm={12} xs={12}>
              <div className={classes.botoesFormulario}>
                <div className={classes.botaoContainer}>
                  {activeStep === 0 ? (
                    <CustomButton
                      variant="outlined"
                      colorType="primary"
                      onClick={() => router.history.goBack()}
                      startIcon={<ArrowBackIcon />}
                      disabled={processando}
                    >
                      Voltar
                    </CustomButton>
                  ) : (
                    <CustomButton
                      variant="contained"
                      colorType="primary"
                      onClick={handleBack}
                      startIcon={<ArrowBackIcon />}
                      disabled={processando}
                    >
                      Etapa Anterior
                    </CustomButton>
                  )}
                </div>
                <div className={classes.botoesDireita}>
                  <div className={classes.botaoContainer}>
                    <CustomButton
                      colorType="secondary"
                      variant="contained"
                      disabled={formError() || processando}
                      isLoading={processando}
                      onClick={handleNext}
                      endIcon={activeStep === steps.length - 1 ? <SaveIcon /> : <ArrowForwardIcon />}
                    >
                      {activeStep === steps.length - 1 ? 'Confirmar Recebimento' : 'Próxima Etapa'}
                    </CustomButton>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Modal de Espelhamento de Dados da Entrega */}
      {dadosFormatados.recebedor && (
        <ModalConfirmacao
          aberto={openEspelho}
          onClose={() => {
            if (!processando) {
              setOpenEspelho(false)
            }
          }}
          onConfirm={handleConfirmar}
          processando={processando}
          titulo="Confirmar Entrega de Cadáver"
          confirmarLabel="Confirmar"
          cancelarLabel="Voltar"
          confirmarColor="secondary"
          maxWidth="md"
        >
          <Grid container spacing={2} className={classes.dadosConfirmacao}>
            <Grid item xs={12}>
              <Typography className={classes.titleCampo}>
                DADOS DO RESPONSÁVEL PELO RECEBIMENTO
              </Typography>
              <Divider className={classes.dividerTitle} />
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <Typography variant="body2" color="textSecondary">
                <b>Nome:</b>
              </Typography>
              <Typography variant="body1">{dadosFormatados.recebedor.nome}</Typography>
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <Typography variant="body2" color="textSecondary">
                <b>Documento:</b>
              </Typography>
              <Typography variant="body1">
                {dadosFormatados.recebedor.tipoDocumento} {dadosFormatados.recebedor.numeroDocumento}{' '}
                {dadosFormatados.recebedor.orgaoEmissorDocumento}
              </Typography>
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <Typography variant="body2" color="textSecondary">
                <b>Telefone:</b>
              </Typography>
              <Typography variant="body1">{dadosFormatados.recebedor.telefone}</Typography>
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <Typography variant="body2" color="textSecondary">
                <b>Grau de relação com o cadáver:</b>
              </Typography>
              <Typography variant="body1">
                {getLabelGrauRelacaoCadaver(dadosFormatados.recebedor.grauRelacao)}
              </Typography>
            </Grid>

            <Grid item xs={12} style={{ marginTop: '16px' }}>
              <Typography className={classes.titleCampo}>
                OUTRAS INFORMAÇÕES
              </Typography>
              <Divider className={classes.dividerTitle} />
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <Typography variant="body2" color="textSecondary">
                <b>Declaração de óbito:</b>
              </Typography>
              <Typography variant="body1">{dadosFormatados.cadaver.declaracaoObito}</Typography>
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <Typography variant="body2" color="textSecondary">
                <b>Cemitério:</b>
              </Typography>
              <Typography variant="body1">{dadosFormatados.cadaver.cemiterio}</Typography>
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <Typography variant="body2" color="textSecondary">
                <b>Localização Interna do cemitério:</b>
              </Typography>
              <Typography variant="body1">{dadosFormatados.cadaver.localizacaoInternaCemiterio}</Typography>
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <Typography variant="body2" color="textSecondary">
                <b>Observações:</b>
              </Typography>
              <Typography variant="body1">{dadosFormatados.cadaver.entregaObservacoes || 'NÃO INFORMADO'}</Typography>
            </Grid>
          </Grid>
        </ModalConfirmacao>
      )}
    </div>
  )
}

Form.propTypes = {
  cadaver: PropTypes.object.isRequired,
}
